import { ImageList, ImageListItem, Stack, Typography } from "@mui/material";

import medik8Products from "../../Assets/medik8_products.png";
import medik8_2 from "../../Assets/medik8_2.jpg";
import classes from "./Medik8.module.css";
import { BOOKING_URL, trackBookingClick } from "../../utils/tracking";
import BookingWidgetSection from "../../Components/BookingWidget/BookingWidgetSection";
import useDocumentMeta from "../../utils/useDocumentMeta";

const Medik8 = () => {
  useDocumentMeta(
    "Medik8 Skincare | Radiance Aesthetics | Hindley | Wigan",
    "Shop Medik8 professional skincare at Radiance Aesthetics, Hindley, Wigan — up to 15% off in clinic, plus a free consultation to find your routine.",
  );

  return (
    <section className={classes.medik8Section}>
      <Stack
        sx={{
          maxWidth: "720px",
          margin: "0 auto",
          alignItems: "center",
          padding: { xs: "20px 16px", md: "20px 24px" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "var(--font-body)",
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            color: "var(--color-accent)",
            textAlign: "center",
            mb: 1.5,
          }}
        >
          Professional Skincare
        </Typography>
        <Typography
          sx={{
            fontFamily: "var(--font-heading)",
            color: "var(--color-primary)",
            fontWeight: 400,
            textAlign: "center",
            fontSize: { xs: "28px", md: "40px" },
            mb: 1.5,
          }}
          variant="h1"
        >
          Medik8
        </Typography>

        <Stack sx={{ width: "100%" }} gap={4}>
          <Typography
            sx={{
              color: "var(--color-text-light)",
              textAlign: "center",
              fontSize: "16px",
              lineHeight: 1.8,
              fontFamily: "var(--font-body)",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            At Radiance Aesthetics, we proudly use and stock the professional
            skincare brand Medik8 for all our treatments. Rooted in science and
            driven by results, Medik8 products are designed to deliver visible
            improvements in skin health.
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text)",
              textAlign: "center",
              fontSize: "16px",
              lineHeight: 1.8,
              fontFamily: "var(--font-body)",
              fontWeight: 500,
              maxWidth: "500px",
              mx: "auto",
              backgroundColor: "var(--color-white)",
              border: "1px solid var(--color-border)",
              borderRadius: "8px",
              p: 2.5,
            }}
          >
            All Medik8 products are currently available at up to 15% off retail
            price when purchased in clinic.
          </Typography>

          <ImageList
            sx={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
              mx: "auto",
            }}
            variant="masonry"
            cols={2}
            gap={12}
          >
            <ImageListItem
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <img
                src={medik8Products}
                alt="Medik8 professional skincare products available at Radiance Aesthetics Wigan"
                loading="lazy"
              />
            </ImageListItem>
            <ImageListItem
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <img
                src={medik8_2}
                alt="Medik8 clinical skincare range for advanced skin concerns"
                loading="lazy"
              />
            </ImageListItem>
          </ImageList>

          <Typography
            sx={{
              color: "var(--color-text-light)",
              textAlign: "center",
              fontSize: "16px",
              lineHeight: 1.8,
              fontFamily: "var(--font-body)",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Not sure which products are right for your skin? Book a free Medik8
            consultation where we'll assess your skin and recommend a tailored
            at-home routine to complement your in-clinic treatments.
          </Typography>

          <Stack alignItems="center">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackBookingClick("Medik8 Consultation")}
              style={{
                display: "inline-block",
                backgroundColor: "#5a4d47",
                color: "#fff",
                padding: "14px 32px",
                borderRadius: "4px",
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: 600,
                fontFamily: "'Montserrat', sans-serif",
                letterSpacing: "0.3px",
                transition: "all 0.3s ease",
              }}
            >
              Book Free Consultation
            </a>
          </Stack>

          <BookingWidgetSection source="Medik8" />
        </Stack>
      </Stack>
    </section>
  );
};

export default Medik8;
